import React from 'react';
import { Input, Select, Radio } from 'antd';

const { Option } = Select;

const createTriggerWindow = (id = Date.now() + Math.random()) => ({
  id,
  days: '',
  field: 'Welcome',
  operator: '=',
  value: '',
});

const TriggerWindowFields = ({ formData, updateField, showValidation = false, errorTriggerWindowDays = false }) => {
  const triggerWindow = Array.isArray(formData?.triggerWindows) && formData.triggerWindows.length > 0
    ? formData.triggerWindows[0]
    : { ...createTriggerWindow('default-trigger-window'), days: formData?.triggerWindowDays || '' };
  const showError = showValidation && errorTriggerWindowDays;

  const updateTriggerWindow = (id, field, value) => {
    const nextWindows = [{ ...triggerWindow, [field]: value }];

    updateField('triggerWindows', nextWindows);

    if (field === 'days') {
      updateField('triggerWindowDays', value);
    }
  };

  return (
    <>
      <div className='step-section-title mb-8'>Trigger Window</div>
      <div className='step-form-hint'>
        This rule fires this many days from the attribute below — e.g. 15 days from welcome_redeemed_flag = true.
      </div>

      <div className='d-flex d-flex-row gap-16 alignCenter mt-16 flex-wrap border-bottom-light pb-16 mb-16'>
        <div key={triggerWindow.id} className='Trigger-attribute-box w-100 border-bottom-light'>

          <div className='step-Trigger d-flex d-flex-row gap-8 alignCenter mb-8 mt-8'>
            <div className="box-with-label d-flex d-flex-col gap-8 alignCenter w-33">
              <label className='step-form-label'>Select Lifecycle Type</label>
              <Select
                value={triggerWindow.field || 'Welcome'}
                onChange={(value) => updateTriggerWindow(triggerWindow.id, 'field', value)}
                className='Input-border InputSelect condition-select w-100'
              >
                <Option value='Welcome'>Welcome</Option>
                <Option value='Anniversary'>Anniversary</Option>
                <Option value='Birthday'>Birthday</Option>
                <Option value='Lapsed'>Lapsed</Option>
              </Select>
            </div>
            <div className="box-with-label d-flex d-flex-col gap-8 alignCenter w-33">
              <label className='step-form-label'>Enter Validity Period (days) <span style={{ color: '#ff4d4f' }}>*</span></label>
              <Input
                value={triggerWindow.days || ''}
                inputMode='numeric'
                status={showError ? 'error' : undefined}
                onChange={(e) => {
                  const rawValue = e.target.value;
                  if (/^\d*$/.test(rawValue)) {
                    updateTriggerWindow(triggerWindow.id, 'days', rawValue);
                  }
                }}
                placeholder='Enter Validity Period (days)'
                className='Input-border InputText w-100'
              />
              {showError && <div className='step-form-hint' style={{ color: '#ff4d4f' }}>Validity Period (days) is required.</div>}
            </div>
            <div className="box-with-label d-flex d-flex-col gap-8 alignCenter w-33">
              <label className='step-form-label'>Redemption Type</label>
              <Radio.Group
                value={formData?.RedemptionType || 'One Time'}
                onChange={(e) => updateField('RedemptionType', e.target.value)}
              >
                <Radio.Button value='One Time'>One Time</Radio.Button>
                <Radio.Button value='Once Per Year'>Once Per Year</Radio.Button>
              </Radio.Group>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TriggerWindowFields;
